import React from 'react'
import './reports.scss'

export const Reports = () => {
    return (
        <div className="main">
            <div className="container">
                <div className="content">
                    <div className="heading">
                        <h3>Reports</h3>
                    </div>
                </div>
            </div>
        </div>
    )
}
